<div class="container">

  <div class="header-top">
    
    <div class="header-left">
      <app-page-close-button (click)="goBack()"></app-page-close-button>
      <div class="title-container">
        <span class="title">      
          @if (readOnlyMode) { View } @else if(masterEditingEnabled) { Edit
          } @else { Add } Location
        </span>

      </div>
    </div>

    <div class="header-right">
      
      <ng-container *ngIf="!readOnlyMode">
        <button type="button" class="secondary_button" (click)="goBack()">
          Cancel
        </button>

        <button type="button" class="primary_button" (click)="submitMasterForm()">
          @if(masterEditingEnabled) { Update } @else { Save }
        </button>
      </ng-container>
      
    </div>
  </div>

  <div class="container-content">

    <div id="basic-details-section" class="section">
      <app-section-header
          [title]="'Location Information'"
          [subtitle]="'Basic information about the location.'"
      ></app-section-header>

      <div class="card-layout">
        <app-dynamic-form [formConfig]="dynamicForm" [formGroup]="masterForm"></app-dynamic-form>
      </div>
    </div>

    <div id="contact-details-section" class="section">
      
      <app-section-header
          [title]="'Contact Information'"
          [subtitle]="'Contact details for the location.'"
      ></app-section-header>

      <div class="card-layout">
        <app-contact-information [contactFormConfig]="contactConfig" [contactInformation]="contactInformation" [action]="contactAction"></app-contact-information>
      </div>

    </div>
  </div>



</div>
